import { ChangeEvent } from 'react'

export default function onChange(maxLength = 0) {
  return function(change: (event: ChangeEvent<HTMLTextAreaElement>) => void) {
    return function(event: ChangeEvent<HTMLTextAreaElement>) {
      const currentValue = event.currentTarget.value || ''
      const allowToChange = maxLength === 0 || currentValue.length <= maxLength

      if (!allowToChange) {
        return
      }

      change(event)
    }
  }
}
